import { IconBookmarks } from '@tabler/icons-react';

interface Props {
  title: string;
  hint?: string;
}

export function EmptyShelf({ title, hint }: Props) {
  return (
    <div className="flex flex-col items-center justify-center pt-16 pb-8 px-6 text-center gap-3">
      <div className="w-20 h-20 rounded-pill bg-surface grid place-items-center text-text-muted/60">
        <IconBookmarks size={36} strokeWidth={1.4} />
      </div>
      <div className="text-sm font-medium text-text">{title}</div>
      {hint && <div className="text-xs text-text-muted max-w-[260px]">{hint}</div>}
    </div>
  );
}
